import React, { useState, useMemo, useRef } from 'react';
import AgGridReact from '../../../common/AgGrid/AgGridReact.jsx';
import { gridTheme } from '../../../common/AgGrid/gridTheme.js';
import { FaIcon } from '../../../common/Icons.jsx';
import { Button } from '../../../bootstrap/index.jsx';
import { ClientSideRowModelModule } from 'ag-grid-community'
import {
  project_entry_path,
  monitoring_report_project_reports_path,
  project_report_edit_report_path
} from '~/routes';

const valueGetter = (params) => {
    params.data ||= {};
    return params.data[params.colDef.colId] || null
  };

const ProjectReportLinkRenderer = ({params, report_id}) => {
    const identifier = params.getValue();
    const {project_id, id} = params.data;
    return <a href={project_report_edit_report_path({project_id: project_id, report_id, project_report_id: id})} 
                target="_blank" 
                style={{color: '#2CB6B2', textDecoration: 'none'}}>
                {identifier}
            </a>
}

const ProjectIdentifierLinkRenderer = (params) => {
    const identifier = params.getValue();
    const {project_id} = params.data;
    return <a href={project_entry_path({project_id: project_id})} 
            target="_blank" 
            style={{color: '#2CB6B2', textDecoration: 'none'}}>
                {identifier}
            </a>
}
const MonitoringReportInfo = ({monitoring_report_id, name, project_reports, source, defaultExpand = false}) => {
    const [show, setShow] = useState(defaultExpand);
    const gridRef = useRef(null);

    const columnDefs = React.useMemo(() =>  [
      {
        field: I18n.t('project_report_identifier'),
        colId: 'project_report_identifier',
        filter: 'agTextColumnFilter',
        valueGetter: valueGetter,
        cellRenderer: (params) => <ProjectReportLinkRenderer params={params} report_id={monitoring_report_id} />,
      },
      {
        field: I18n.t('project_id'),
        colId: 'project_identifier',
        filter: 'agTextColumnFilter',
        valueGetter: valueGetter,
        cellRenderer: ProjectIdentifierLinkRenderer,
      },
      {
        field: I18n.t('project_title_long'),
        colId: 'project_title',
        filter: 'agTextColumnFilter',
        valueGetter: valueGetter
      },
    ], [])
  
    const status_param = useMemo(() => {
      switch(source){
        case 'workflow_completion':
        case 'completed_submissions':
          return {status: 'project_report_current_status_approved'}
        case 'review_entries':
          return {status:'project_report_current_status_in_review'}
        case 'draft_entries':
          return {status:'draft'}
        default: 
          return {}
      }
    }, [source])

    const project_reports_param = useMemo(() => {
      if (source || (project_reports || []).length === 0) return {};
      return {project_report_ids: project_reports.map((report) => report.id)}
    }, [project_reports])
  
    return (
      <div>
        <div className="mb-1 d-flex" style={{backgroundColor: '#d9edf7', alignItems: 'center', padding: '0.5rem', justifyContent: 'space-between'}}>
          <div className='d-flex' onClick={(e) => setShow(!show)} style={{cursor: 'pointer', alignItems: 'center'}}>
            <FaIcon type={show ? 'chevron-down' : 'chevron-right'} className='ml-1 mr-1' />
            <h4 style={{margin: '0 1rem 0 0'}}>{name}</h4>
            {` (${project_reports.length} ${I18n.t('submissions')})`}
          </div>
          <Button type='link' onClick={() => {window.open(monitoring_report_project_reports_path({...status_param , ...project_reports_param, id: monitoring_report_id, _options: true}))}}>
            {I18n.t('go_to_workflow')}
          </Button>
        </div>
        {
          show ? 
          <div
                id={`table-${monitoring_report_id}`}
                className='grid-theme mb-1'
                style={{
                  width: '100%',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  height: '250px'
                }}
              >
                <AgGridReact theme={gridTheme}
                  groupHeaderHeight={20}
                  ref={gridRef}
                  columnDefs={columnDefs}
                  rowData={project_reports}
                  onGridReady = {params => {
                    params.api.sizeColumnsToFit();
                  }}
                  modules={[ClientSideRowModelModule]}
                />
              </div> : null
        }
      </div>
    )
}

export default MonitoringReportInfo;
